import BackendClient from '../../backend-client';
import Incident, { modelFactory } from './model';
import { formatFilter } from '../filters';

export default class IncidentClient extends BackendClient {
  constructor(options = {}) {
    super(modelFactory, options);
  }

  /* async create(element, type, data) {
    try {
      const response = await this.request('post', 'create')({
        element,
        type,
        data,
      }, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
      });

      return this.format(response);
    } catch (ex) {
      throw this.handleError(ex);
    }
  } */

  list = async (start, size, filters = {}, sortparam, asc) => {
    const sort = `${sortparam} ${asc === true ? 'asc' : 'desc'}`;
    const response = await this.request('get', 'list')({
      filters,
      start,
      size,
      sort,
    });

    return this.format(response);
  }

  detail = (type, idTicket, user, filters = {}) => {
    const filtersF = formatFilter(filters);
    const userFilter = { $or: [{ customer: `U'${user}'` }, { requestedBy: `U'${user}'` }] };
    const sendFilters = {
      type,
      idTicket,
    };
    filtersF.$and.push(userFilter);
    filtersF.$and.push(sendFilters);
    if (type === 'R') {
      this.$path = 'cr';
    } else if (type === 'I') {
      this.$path = 'in';
    } else if (type === 'P') {
      this.$path = 'pr';
    }
    return this.req(JSON.stringify(filtersF));
  }
}

export {
  Incident,
};
